import React from 'react';
import {
  cityListConfig,
  defaultConfig,
  sortTypeConfig,
} from 'components/search/components/filterOptions/config';
import { IFilterItem, ISelectedItem, IQueryParams } from 'components/search/type';

interface ISearchParams {
  selectedOptions: IQueryParams;
  setSelectedOptions: (args?: any) => void;
  cityConfig: IFilterItem[];
  setCityConfig: (args: any) => void;
  config: IFilterItem[];
  setConfig: (args: any) => void;
  sortTypeConfig: IFilterItem;
  selectedList: ISelectedItem[];
  setSelectedList: (args: any) => void;
  queryKey: string;
  setQueryKey: (key: string) => void;
  pageNum: number;
  setPageNum: (pageNum: number) => void;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
  sortType: string;
  setSortType: (sortType: string) => void;
}

const defaultValue = {
  selectedOptions: {},
  setSelectedOptions: () => {},
  cityConfig: cityListConfig,
  setCityConfig: () => {},
  config: defaultConfig,
  sortTypeConfig,
  setConfig: () => {},
  selectedList: [],
  setSelectedList: () => {},
  queryKey: '',
  setQueryKey: () => {},
  pageNum: 1,
  setPageNum: () => {},
  pageSize: 20,
  setPageSize: () => {},
  sortType: '0',
  setSortType: () => {},
};
const SearchContext = React.createContext<ISearchParams>(defaultValue);

export { SearchContext, defaultValue };
